import React, { useState, useEffect } from "react";
import { Input, Button, Form } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { gqlBuilderWhere, helperFunc } from "common/utils";
import FlooringForms from "../../forms";
import Icons from "components/icons";
import { DrawerStandart, Localize } from "components/service";
import { IFilter } from 'components/flooring/helpers/flooring-types-helper';

const { Search } = Input;


interface IFilterList
{
  [ key: string ]: IFilter;
}

interface IFlooringFiltersFormProps
{
  setSearchText: React.Dispatch<React.SetStateAction<string>>;
  setFilters: React.Dispatch<React.SetStateAction<IFilter | undefined>>;
  setResetSorting: React.Dispatch<React.SetStateAction<{ column: string; order: "ASC" | "DESC" }[] | undefined>>;
  flooringFilters: { [ key: string ]: IFilter } | undefined;
  filters: IFilter | undefined;
  objOrderBy: { column: string; order: string }[];
}


const FlooringTableFilter: React.FC<IFlooringFiltersFormProps> = ({
  setFilters = () => { },
  setResetSorting = () => { },
  flooringFilters,
  filters,
  setSearchText,
  objOrderBy,
}) =>
{
  const [ form ] = Form.useForm();

  const [ filterList, setFilterList ] = useState<IFilterList | undefined>(undefined);
  const [ count, setCount ] = useState<any>({});

  const filterCount = helperFunc.countFilterList(count);

  /*eslint-disable */
  useEffect(() =>
  {
    if (filters) {
      localStorage.setItem(
        "flooringFilters",
        JSON.stringify({ ...flooringFilters, ...filterList })
      );
    } else form.resetFields([ "SUPPLIER_ID", "TYPE", "COLOR" ]);
  }, [ filters ]);

  useEffect(() =>
  {
    if (flooringFilters) {
      setFilters(gqlBuilderWhere(flooringFilters));
    }

    setCount({
      ...flooringFilters,
    });
  }, []);
  /*eslint-enable */

  return (
    <>
      <Search
        className="filter-search"
        prefix={<SearchOutlined />}
        onChange={(e) => setSearchText(e.target.value)}
      />
      <Form
        key="filters-form"
        className="clear-css-prop table-filter-form"
        layout="vertical"
        form={form}
      >
        <DrawerStandart
          extraClass={"modal-form filters"}
          modalButton={
            <Button icon={<Icons.Filter />}>
              <span className="ellipsis">
                <Localize>FORMS.Button_Text_Filters</Localize>
              </span>
              {!!filterCount && (
                <span className="filter-count">{filterCount}</span>
              )}
            </Button>
          }
        >
          <strong className="modal-title">
            <span className="text">
              <Localize>FORMS.Title_Text_Filters</Localize>
            </span>
          </strong>

          <FlooringForms.Filter
            setCount={setCount}
            setFilters={(filters) => setFilters(filters as IFilter)}
            setFilterList={setFilterList}
            filterList={filterList}
            flooringFilters={flooringFilters}
            gqlBuilderWhere={gqlBuilderWhere}
            form={form}
            action={() => { }}
          />
        </DrawerStandart>

        {filters && (
          <Button
            className="underline"
            onClick={() =>
            {
              setCount({});
              setFilterList({});
              setFilters(gqlBuilderWhere({}));
              setResetSorting(objOrderBy as { column: string; order: "ASC" | "DESC" }[]);
              localStorage.removeItem("flooringFilters");
              localStorage.removeItem("flooringSorting");
            }}
          >
            <span>
              <Localize>FORMS.Button_Text_Reset</Localize>
            </span>
          </Button>
        )}
      </Form>
    </>
  );
};

export default FlooringTableFilter;
